import {
  takeLatest, select, call,
  delay,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { config } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import { MerlinActionTypes } from '@/redux/modules/merlin/merlin.types';
import { put } from 'redux-saga-test-plan/matchers';
import { merlinActions } from '@/redux/modules';


const { WHMCS_URL } = config;

function* requestMerlinToken() {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/ai-agents/generate-token`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
  };
  try {
    const response = yield call(api.whmcs.get, request);
    yield put(merlinActions.merlinTokenSuccess(response.data.data.token));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    yield put(merlinActions.merlinTokenFail());
    logger.error('Error sagas requestMerlinToken', error);
  }
}

function* sendMessage(data) {
  const { payload } = data;
  const {
    setLoading, threadId, route,
  } = payload;
  const bufferToBase64 = buffer => Buffer.from(buffer).toString('base64');

  const urlProtocol = 'https://';
  const connectionUrl = `${urlProtocol}flow.hostgator.com.br/${route}`;

  const request = {
    url: `${connectionUrl}`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...payload,
    },
  };

  if (payload.file) {
    request.data.file = bufferToBase64(payload.file);
  }

  setLoading && setLoading(true);
  try {
    const response = yield call(api.n8n.post, request);
    yield put(merlinActions.inhouse.requestAnswer({
      answerId: response.data,
      setLoading,
      threadId,
      connectionUrl,
    }));
  } catch (requestError) {
    setLoading && setLoading(false);
  }
}

function* sendAudioMessage(data) {
  const {
    file, token, accountId, threadId, env, brand, url,
  } = data.payload;

  const urlProtocol = 'https://';
  const connectionUrl = `${urlProtocol}flow.hostgator.com.br`;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('token', token);
  formData.append('accountId', accountId);
  formData.append('threadId', threadId);
  formData.append('env', env);
  formData.append('brandName', brand);
  formData.append('url', url);

  const request = {
    url: `${connectionUrl}/ai-agents/chat/transcribe-audio`,
    data: formData,
  };

  yield put(merlinActions.inhouse.setLoadingTranscription(true));
  try {
    const response = yield call(api.n8n.post, request);

    yield put(merlinActions.inhouse.getAudioTranscription({
      result: response.data.result,
    }));
  } catch (requestError) {
    yield put(merlinActions.inhouse.setLoadingTranscription(false));
  }
}

function* pocRequestAnswer(data) {
  const {
    answerId, setLoading, threadId, connectionUrl,
  } = data.payload;
  const request = {
    url: `${connectionUrl}/execution?executionId=${answerId}&threadId=${threadId}`,
  };
  try {
    const response = yield call(api.n8n.get, request);
    const { finished, output } = response.data;

    if (!finished || !output) {
      yield delay(5000);
      yield put(merlinActions.inhouse.requestAnswer({
        answerId, setLoading, threadId, connectionUrl,
      }));
    }

    if (finished && output) {
      const outputArray = output.map(item => ({
        ...item,
        src: 'bot',
      }));
      setLoading && setLoading(false);
      yield put(merlinActions.inhouse.setMessage(outputArray));
    }
  } catch (requestError) {
    setLoading && setLoading(false);
  }
}

function* aiChatRateMessage(data) {
  const {
    url,
    env,
    threadId,
    accountId,
    token,
    messageId,
    rating,
    apiAuthKey,
    brandName,
  } = data.payload;

  const urlProtocol = 'https://';
  const connectionUrl = `${urlProtocol}flow.hostgator.com.br/ai-agents/chat/rate-message`;

  const request = {
    url: connectionUrl,
    data: {
      url,
      env,
      threadId,
      accountId,
      token,
      messageId,
      rating,
      apiAuthKey,
      brandName,
    },
  };

  try {
    yield call(api.n8n.post, request);
    yield put(merlinActions.inhouse.successRateMessage());
  } catch (requestError) {
    yield put(merlinActions.inhouse.failureRateMessage());
  }
}


function* sagas() {
  yield takeLatest(MerlinActionTypes.MERLIN_GENERATE_TOKEN, requestMerlinToken);
  yield takeLatest(MerlinActionTypes.POC_SEND_DOUBT, sendMessage);
  yield takeLatest(MerlinActionTypes.POC_REQUEST_ANSWER, pocRequestAnswer);
  yield takeLatest(MerlinActionTypes.SEND_AUDIO_MESSAGE, sendAudioMessage);
  yield takeLatest(MerlinActionTypes.AI_CHAT_RATE_MESSAGE, aiChatRateMessage);
}

export default sagas;
